import { isOnPremUser } from "helpers/utility/utilities";
import Cookies from "js-cookie";

import { User } from "types";

export function selectUser(state?: any): User | null {
  let session = Cookies.get("SESSION");
  if (typeof session !== "undefined") {
    return { session: session, origin: Cookies.get("user_origin") };
  }

  return null;
}

export function isAnonymousUser(): Boolean {
  const cookieValue = Cookies.get("is_anonymous_user");
  return cookieValue !== undefined && cookieValue.toLowerCase() === "true";
}

export function userLogout() {
  try {
    Cookies.remove("user_token");
    Cookies.remove("user_origin");
    Cookies.remove("is_anonymous_user");
    Cookies.remove("SESSION");
    localStorage.removeItem("vl_user_info");

    // For on-prem with OIDC enabled, redirect to OIDC login
    const authEnabled =
      process.env.REACT_APP_IS_AUTHENTICATION_DISABELED !== "true";
    if (isOnPremUser() && authEnabled) {
      window.location.href = "/api/v1/oidc/logout";
      return;
    }

    let path = isOnPremUser() ? "/login" : "/free-trial";
    if (window.location.pathname !== "/" || window.location.search !== "") {
      const currentPath = window.location.pathname + window.location.search;
      path = path + "?next=" + encodeURIComponent(currentPath);
    }
    window.location.href = path;
  } catch (e) {
    console.log(e);
  }
}
